import React from 'react';
import {
  FaTaxi,
  FaPlane,
  FaHospitalUser,
  FaMoneyBillWave,
  FaUsers,
  FaWhatsapp,
  FaPhoneAlt,
  FaClock,
  FaStar,
} from 'react-icons/fa';

import '../styles/Home.css';
import heroImage from '../assets/montbeliard.jpg';
import logo from '../assets/logo.png';

const services = [
  {
    icon: <FaTaxi />,
    title: 'Toutes distances',
    text: 'Déplacements locaux et longues distances.',
  },
  {
    icon: <FaPlane />,
    title: 'Aéroports',
    text: 'Bâle-Mulhouse, Strasbourg, Dole.',
  },
  {
    icon: <FaHospitalUser />,
    title: 'Taxi conventionné',
    text: 'Transport médical sur réservation.',
  },
  {
    icon: <FaMoneyBillWave />,
    title: 'Paiement facile',
    text: 'CB, espèces et sans contact.',
  },
  {
    icon: <FaUsers />,
    title: 'Familles',
    text: 'Adultes, enfants et seniors.',
  },
];

function Home() {
  return (
    <>
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay">
          <img src={logo} alt="ASPROTAXI" className="logo" />

          <h1>ASPROTAXI</h1>

          <h2>Taxi Montbéliard • Sainte-Suzanne</h2>

          <p>
            Votre chauffeur disponible 7j/7 pour tous vos déplacements.
          </p>

          <div className="hero-buttons">
            <a href="tel:+33777685938" className="call-btn">
              <FaPhoneAlt />
              Réserver maintenant
            </a>

            <a
              href="https://wa.me/33777685938"
              target="_blank"
              rel="noreferrer"
              className="whatsapp-btn"
            >
              <FaWhatsapp />
              WhatsApp
            </a>
          </div>

          <div className="stats">
            <div>
              <FaClock />
              <strong>24h/24</strong>
              <span>Disponibilité</span>
            </div>

            <div>
              <FaTaxi />
              <strong>7j/7</strong>
              <span>Réservation</span>
            </div>

            <div>
              <FaStar />
              <strong>★★★★★</strong>
              <span>Service qualité</span>
            </div>
          </div>
        </div>
      </section>

      <section className="services">
        <h2>Nos Services</h2>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                {service.icon}
              </div>

              <h3>{service.title}</h3>

              <p>{service.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="medical-banner">
        <h2>🏥 Taxi Conventionné</h2>
        <p>
          Transport médical assis professionnel sur réservation.
        </p>
      </section>

      <section className="contact">
        <h2>Besoin d'un taxi ?</h2>

        <a href="tel:+33777685938" className="contact-btn">
          📞 07 77 68 59 38
        </a>
      </section>

      <a href="tel:+33777685938" className="floating-phone">
        📞
      </a>
    </>
  );
}

export default Home;
